import { useTranslation } from 'react-i18next';

export default function DraftMark() {
  const { t } = useTranslation('infoblob');

  return <div className="info-blob">{t('isDraft')}</div>;
}
